// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.casesBanner {
  display: flex;
  gap: 10px;
  height: 250px;
  margin-bottom: 30px;
  flex-direction: row;
  flex-wrap: wrap;
}
@media (max-width: 480px) {
  .casesBanner {
    height: 50px;
    margin-bottom: 0;
    justify-content: space-between;
  }
}
@media (max-width: 960px) {
  .casesBanner {
    height: 150px;
    gap: 20px;
  }
}
.casesBanner .case {
  flex: 1 1;
  border-radius: 10px;
  min-width: 100px;
  max-width: 200px;
  overflow: hidden;
  position: relative;
}
@media (max-width: 480px) {
  .casesBanner .case {
    flex: none;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
}
.casesBanner .case img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.casesBanner .case span {
  position: absolute;
  bottom: 10px;
  left: 50px;
  font-size: x-large;
  color: white;
  background-color: #5271ff;
  border-radius: 10%;
  font-weight: 500;
}
@media (max-width: 480px) {
  .casesBanner .case span {
    display: none;
  }
}
.casesBanner .case button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: white;
  background-color: #5271ff;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 480px) {
  .casesBanner .case button {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/cases/cases.scss","webpack://./src/style.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AADF;ACoCE;EDzCF;IASI,YAAA;IACA,gBAAA;IACA,8BAAA;EAAF;AACF;ACkCE;ED9CF;IAeI,aAAA;IACA,SAAA;EACF;AACF;AACE;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;ACeE;EDtBA;IASI,UAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;EAEJ;AACF;AAAI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAEN;AAAI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;AACN;ACRE;EDFE;IAWI,aAAA;EAGN;AACF;AAAI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEN;AC7BE;EDaE;IAiBG,OAAA;IACA,QAAA;IACA,MAAA;IACA,SAAA;IACA,YAAA;EAGL;AACF","sourcesContent":["@import \"../../style.scss\";\n\n.casesBanner {\n  display: flex;\n  gap: 10px;\n  height: 250px;\n  margin-bottom: 30px;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  @include mobile {\n    height: 50px;\n    margin-bottom: 0;\n    justify-content: space-between;\n  }\n\n  @include tablet{\n    height: 150px;\n    gap: 20px;\n  }\n\n  .case {\n    flex: 1;\n    border-radius: 10px;\n    min-width: 100px;\n    max-width: 200px;\n    overflow: hidden;\n    position: relative;\n\n    @include mobile {\n      flex: none;\n      width: 50px;\n      height: 50px;\n      border-radius: 50%;\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n    span {\n      position: absolute;\n      bottom: 10px;\n      left: 50px;\n      font-size: x-large;\n      color: white;\n      background-color: #5271ff;\n      border-radius: 10%;\n\n      font-weight: 500;\n      @include mobile {\n        display: none;\n      }\n    }\n\n    button {\n      position: absolute;\n      bottom: 10px;\n      right: 10px;\n      color: white;\n      background-color: #5271ff;\n      border: none;\n      border-radius: 50%;\n      width: 30px;\n      height: 30px;\n      cursor: pointer;\n      font-size: 30px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      @include mobile {\n       left: 0;\n       right: 0;\n       top: 0;\n       bottom: 0;\n       margin: auto;\n      }\n    }\n  }\n}\n","$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
